"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomObjectEntry = exports.getRandomArrayItem = exports.getRandomId = exports.getRandomInt = void 0;
function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    //The maximum is exclusive and the minimum is inclusive
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
exports.getRandomInt = getRandomInt;
function getRandomArrayItem(_a) {
    var array = _a.array, _b = _a.start, start = _b === void 0 ? 0 : _b;
    var randomIndex = getRandomInt(start, array.length - 1);
    return array[randomIndex];
}
exports.getRandomArrayItem = getRandomArrayItem;
function getRandomObjectEntry(_a) {
    var object = _a.object, _b = _a.start, start = _b === void 0 ? 0 : _b;
    var array = Object.keys(object);
    var randomIndex = getRandomArrayItem({
        array: array,
        start: start
    });
    return object[randomIndex];
}
exports.getRandomObjectEntry = getRandomObjectEntry;
function getRandomId() {
    var e_1, _a;
    var num = "";
    var array = new Uint8Array(30);
    window.crypto.getRandomValues(array);
    try {
        for (var array_1 = __values(array), array_1_1 = array_1.next(); !array_1_1.done; array_1_1 = array_1.next()) {
            var n = array_1_1.value;
            num += n.toString(16);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (array_1_1 && !array_1_1.done && (_a = array_1.return)) _a.call(array_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return num;
}
exports.getRandomId = getRandomId;
